import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { fetchData, youtubeSearchOptions } from "../../utils/fetchData";

import Detail from "./components/Detail";
import ExerciseVideos from "./components/ExerciseVideos";
import SimilarExercises from "./components/SimilarExercises";

const ExerciseDetail = () => {
  const { allExercises, isLoading } = useOutletContext();
  const [exerciseVideos, setExerciseVideos] = useState([]);
  const [videoIsLoading, setVideoIsLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  const [exercise, setExercise] = useState({});

  useEffect(() => {
    setVideoIsLoading(true);
    const searchExercise = allExercises.find((exercise) => exercise.id === id);

    if (!searchExercise && !isLoading) {
      navigate("/404");
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const youtubeSearchUrl =
      "https://youtube-search-and-download.p.rapidapi.com";
    const fetchYoutubeVideos = async () => {
      const exerciseVideos = await fetchData(
        `${youtubeSearchUrl}/search?query=${searchExercise?.name}`,
        youtubeSearchOptions
      );

      // console.log("ExerciseDetails: Exercise Video Results: ", exerciseVideos);
      setExerciseVideos(exerciseVideos?.contents);
      setVideoIsLoading(false);
    };
    setExercise(searchExercise);
    fetchYoutubeVideos();
  }, [allExercises, id, navigate, isLoading]);

  console.log("The Exercises ", exercise);

  const similarTarget = allExercises
    .filter(
      (item) => item.target === exercise?.target && item.id !== exercise.id
    )
    .slice(0, 4);

  const similarEquipment = allExercises
    .filter(
      (item) => item.equipment === exercise.equipment && item.id !== exercise.id
    )
    .slice(0, 4);

  return (
    <Box>
      <Detail exerciseDetail={exercise} />
      <ExerciseVideos
        isLoading={videoIsLoading}
        exerciseVideos={exerciseVideos}
        name={exercise?.name}
      />
      <SimilarExercises
        targetMuscleExercises={similarTarget}
        equipmentExercises={similarEquipment}
      />
    </Box>
  );
};

export default ExerciseDetail;
